import { LandingPage } from '../../views/pages/LandingPage';
import { Privacy } from '../../views/pages/Privacy';
import UserVerification from '../../views/pages/UserVerification';

export const publicRoutes = [
  { path: '/', element: <LandingPage /> },
  { path: '/privacy', element: <Privacy /> },
  { path: '/verification/:token', element: <UserVerification /> },
];
